var map = {
	"./1.png": "cfe1",
	"./1down.png": "f948",
	"./1up.png": "0b82",
	"./2.png": "1188",
	"./3.png": "e31d",
	"./down.png": "5eed",
	"./up.png": "8d7a",
	"./vector.png": "fad0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0e46";